import { Box } from '@chakra-ui/react';
import MarkdownRenderer from 'components/MarkdownRenderer';
import { motion, useAnimation } from 'framer-motion';
import { BLINKING_CURSOR_VISIBLE_TIME, DISPLAY_TEXT_TIME_SPEED } from 'helpers/constant';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const TypingText = () => {
  const [displayText, setDisplayText] = useState('');
  const [cursorVisible, setCursorVisible] = useState(true);

  const blinkCursorRef = useRef<HTMLDivElement>(null);
  const controls = useAnimation();
  const { current, processingStreamingChunkStatus } = useSelector((store) => store.conversations);
  const setRefBoxHeight = current.answerChunks.chunk ? '70px' : '';

  useEffect(() => {
    blinkCursorRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [current.answerChunks.chunk, processingStreamingChunkStatus, blinkCursorRef]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayText(current.answerChunks.chunk.substring(0, displayText.length + 1));
    }, DISPLAY_TEXT_TIME_SPEED);

    return () => clearInterval(interval);
  }, [displayText, current.answerChunks.chunk]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setCursorVisible((prev) => !prev);
    }, BLINKING_CURSOR_VISIBLE_TIME);

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <>
      <Box pos='relative'>
        {/* Render markdown WHILE streaming so lists/bold/headings/tables format live, not only
            after the final answer. The blinking caret is appended into the content so it flows
            inline with the markdown instead of dropping to its own line. (#78825) */}
        <motion.div animate={controls} initial={{ opacity: 1 }}>
          <MarkdownRenderer content={`${displayText}${cursorVisible ? ' ▍' : ''}`} />
        </motion.div>
      </Box>
      <Box ref={blinkCursorRef} h={setRefBoxHeight}></Box>
    </>
  );
};

export default TypingText;
